var exports = {
  "N": "ProfileCardFooter.module__footerSection___VzM4SF",
};

module.exports = exports;
